import { pick } from 'ramda'
import { useFilterActions, useFilterState } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { truncateString } from '../../../utils/helpers/string'
import { useRemoveView } from '../select/_request/removeViewRequest'
import { useScreenViewsLoader } from './_load/screenViewsLoader'
import Dropdown from '../../../packages/kiti/components/navigation/Dropdown'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Link from '../../../packages/kiti/components/actions/Link'
import Loading from '../../../packages/kiti/components/helpers/Loading'

const ScreenViewDropdown = ({ screen, ignoreFields, ...props }) => {
  const { view, filter } = useFilterState()
  const { setView, clearView } = useFilterActions()
  const getOptions = useScreenViewsLoader({ screens: screen, fromMobile: false })

  const handleChange = value => {
    setView({
      ...value, //
      filters: { ...(value?.filters || {}), ...pick(ignoreFields || [], filter) }
    })
  }

  const [removeView, { loading }] = useRemoveView()
  const handleRemoveFilter = viewId => e => {
    e.stopPropagation()
    removeView(viewId)
    if (view?.id === viewId) clearView()
  }

  const handleGetOptions = (...params) => {
    return getOptions(...params).then(options =>
      options.map(option => ({
        ...option,
        rightContent: (
          <Link onClick={handleRemoveFilter(option.id)}>
            <Icon name="BsTrash" size={0.7} color="red" />
          </Link>
        )
      }))
    )
  }

  const { t } = useTranslation('common')
  if (loading) return <Loading />

  return (
    <Dropdown label={truncateString(view?.name || t('views'), 10)} onChange={handleChange} options={handleGetOptions} />
  )
}

export default ScreenViewDropdown
